import React, { useState, useEffect, useMemo } from "react";
import { Dropdown, List, Button, Form, Icon, Label, Radio } from "semantic-ui-react";
import Joi from "joi";
import { find, reject, isEqual, trim, difference, concat, isEmpty, get, map, includes, orderBy, filter } from "lodash";
import PropTypes from "prop-types";

// redux
import genericAction from "@Actions/generic";
import { connect } from "react-redux";

// Components
import Input from "@Components/Input";
import Text from "@Components/Text";
import IKModal from "@Components/IkModal";

// Modals
import ConfirmModal from "@Modals/ConfirmModal";

// Utils
import { dropdownFormat } from "@Utils/formats";

// Styles
import styles from "./styles.module.css";

const invitations = ({ tableValue, modalCrud, onClose, user, groupsList, profileList, companyName, apiData, dispatch }) => {
	const schema = Joi.object().keys({
		email: Joi.string()
			.email({ tlds: { allow: false } })
			.required()
			.messages({
				"string.email": "El Correo / Teléfono debe ser válido",
				"string.empty": "Correo / Teléfono es un campo requerido",
			}),
		profile: Joi.number().min(0).messages({
			"number.base": "Perfil es un campo requerido",
		}),
		groupsSelected: Joi.array().min(1).required().messages({
			"array.length": "Se debe seleccionar al menos un grupo",
		}),
	});

	const [open, setOpen] = useState(false);

	const [groupDateAdd, setGroupDateAdd] = useState([]);
	const [groupDateRejected, setGroupDateRejected] = useState([]);
	const [groupsSelected, setGroupsSelected] = useState([]);

	const [email, setEmail] = useState("");
	const [profile, setprofile] = useState("");
	const [profileData, setProfileData] = useState([]);
	const [groupField, setGroupField] = useState([]);
	const [groupsData, setGroupsData] = useState([]);
	const [groupDateDisp, setGroupDateDisp] = useState([]);
	const [errors, setErrors] = useState({ email: "" });
	const [initialFormData, setInitialFormData] = useState({
		groupsSelected: [],
		email: "",
		profile: "",
	});
	const [modalOption, setModalOption] = useState("");

	useEffect(() => {
		setModalOption(modalCrud);
		const profileDataVal = dropdownFormat(profileList, "name", "id");
		setGroupsData(groupsList);
		setProfileData(profileDataVal);

		if (modalCrud === "Watch") {
			setEmail(get(tableValue, "email", ""));
			setprofile(get(tableValue, "profileId", ""));
			const mapGroups = map(get(tableValue, "groups", []), (item) => {
				return find(groupsList, { id: item });
			});
			setGroupsSelected(mapGroups);
			setInitialFormData({
				groupsSelected: mapGroups,
				email: get(tableValue, "email", ""),
				profile: get(tableValue, "profileId", ""),
			});
		} else {
			groupFilter("Todo", groupsList);
		}
	}, [tableValue]);

	const renderListSelecionados = useMemo(() => {
		return groupsSelected
			.filter((key) => {
				return !!key && key.name;
			})
			.map((key) => {
				return (
					<List.Item
						key={key.id}
						className={find(groupDateRejected, key) === undefined ? styles.listText : styles.listTextPress}
						onDoubleClick={() => {
							if (modalOption !== "Watch") {
								passDataRejected(key);
								passDataDelete();
							}
						}}
						onClick={() => {
							if (modalOption !== "Watch") {
								passDataRejected(key);
							}
						}}>
						{key.name}
					</List.Item>
				);
			});
	}, [groupsSelected, groupDateRejected]);

	const renderListDisponibles = useMemo(() => {
		return map(groupDateDisp, (key) => {
			return (
				<List.Item
					className={find(groupDateAdd, key) === undefined ? styles.listText : styles.listTextPress}
					onDoubleClick={() => {
						if (modalOption !== "Watch") {
							passDataAdd(key);
							passDataConfirm();
						}
					}}
					onClick={() => {
						if (modalOption !== "Watch") {
							passDataAdd(key);
						}
					}}>
					{key.name}
				</List.Item>
			);
		});
	}, [groupDateDisp, groupDateAdd]);
	const passDataDelete = () => {
		const groupDisp = concat(groupDateRejected, groupDateDisp);
		const posicion = difference(groupsSelected, groupDateRejected);
		setGroupDateDisp(groupDisp);
		setGroupsSelected(posicion);
		setGroupDateRejected([]);
	};

	const passDataConfirm = () => {
		const groupSelect = concat(groupsSelected, groupDateAdd);
		const groupDisp = difference(groupDateDisp, groupDateAdd);
		setGroupDateDisp(groupDisp);
		setGroupsSelected(groupSelect);
		setGroupDateAdd([]);
	};

	const passDataRejected = (value) => {
		const datos = find(groupDateRejected, value);
		if (!datos) {
			setGroupDateRejected([...groupDateRejected, value]);
		} else {
			const posicion = reject(groupDateRejected, value);
			setGroupDateRejected(posicion);
		}
	};

	const passDataAdd = (value) => {
		const datos = find(groupDateAdd, value);
		if (!datos) {
			setGroupDateAdd([...groupDateAdd, value]);
		} else {
			const posicion = reject(groupDateAdd, value);
			setGroupDateAdd(posicion);
		}
	};

	const saveData = async () => {
		const validation = schema.validate({ email, profile, groupsSelected }, { abortEarly: false });
		if (validation.error) {
			const { details } = validation.error;
			let errorsVal = { email: "", profile: "", groupsSelected: "" };
			map(details, (item) => {
				errorsVal = { ...errorsVal, [item.context.key]: item.message };
			});
			setErrors(errorsVal);
		} else {
			const groups = map(groupsSelected, (item) => {
				return item.id;
			});
			const data = {
				email: trim(email),
				link: `${window.location.origin}`,
				groups,
				profileId: profile,
				permissions: get(user, "permissions", []),
				companyName,
			};
			const sendData = await dispatch(genericAction({ method: "post", route: "/invitations", body: data }));

			if (!isEmpty(sendData)) {
				setprofile("");
				setErrors({ email: "" });
				setGroupDateDisp(groupsList);
				setGroupsSelected([]);
				setGroupDateAdd([]);
				setEmail("");

				apiData("Add", sendData);
			}
		}
	};

	const handleInput = (e) => {
		const { value } = e.target;
		setEmail(value);
	};
	// save handlers

	const handleSearchDropdown = (e, value) => {
		setprofile(value.value);
	};

	// modal handlers
	const cancelModal = () => {
		onClose();
	};

	const modalOpen = () => {
		if (isEqual({ groupsSelected, email, profile }, initialFormData)) {
			cancelModal();
		} else if (open) {
			setOpen(false);
		} else {
			setOpen(true);
		}
	};
	const groupFilter = (type, array) => {
		if (type === "Todo") {
			setGroupField(type);

			const groupArray = reject(array, (item) => {
				return includes(groupsSelected, item);
			});

			setGroupDateDisp(orderBy(groupArray, ["name"], ["asc"]));
		} else {
			const groupArrayReject = reject(array, (item) => {
				return includes(groupsSelected, item);
			});

			const groupArray = filter(groupArrayReject, (item) => {
				return item.type.name === type;
			});
			setGroupField(type);
			setGroupDateDisp(orderBy(groupArray, ["name"], ["asc"]));
		}
	};
	return (
		<>
			<IKModal
				title={modalOption === "Add" ? "Agregar Invitaciones" : `Invitaciones: ${get(tableValue, "email", "")} `}
				id={tableValue.id}
				mode={modalOption}
				setMode={setModalOption}
				onClose={modalOpen}
				onSuccess={saveData}
				size="small">
				<div className={styles.grid}>
					<Form>
						<div className={styles.containerMain}>
							<div className={styles.container}>
								<fieldset className={styles.fieldset}>
									<legend className={styles.legend}>
										<div className={styles.flexWidth}>
											<Icon name="book" />
											<div className={styles.titleBox}>
												Información Del Usuario <span className={styles.required}>*</span>
											</div>
										</div>
									</legend>
									<div className={styles.row}>
										<Form className={styles.containerEmail}>
											<Text className={errors.profile ? styles.TextRolError : styles.TextRol}>
												Correo / Teléfono: <span className={styles.required}>*</span>
											</Text>
											<Input
												name="email"
												disabled={modalOption === "Watch"}
												error={!isEmpty(errors.email) && { content: errors.email, pointing: "above" }}
												fluid
												placeholder="Ingrese su Correo o Télefono"
												className={styles.InputEmail}
												value={email}
												onChange={handleInput}
											/>
										</Form>
										<Form className={styles.containerEmail}>
											<Text className={errors.profile ? styles.TextRolError : styles.TextRol}>
												Elige su Perfil:<span className={styles.required}> *</span>
											</Text>
											<Dropdown
												fluid
												disabled={modalOption !== "Add"}
												options={profileData || []}
												selection
												clearable
												value={profile}
												name="profile"
												placeholder="Seleccionar"
												search
												onChange={handleSearchDropdown}
											/>
											{!isEmpty(errors.profile) && (
												<Label className={styles.labelError} basic color="red" pointing="above">
													{errors.profile}
												</Label>
											)}
										</Form>
									</div>
								</fieldset>

								<fieldset className={styles.fieldset}>
									{errors.groupsSelected && (
										<div className={styles.center}>
											<Label className={styles.labelError} basic color="red" pointing="above">
												Debe selecionar al menos un grupo
											</Label>
										</div>
									)}
									<legend className={styles.legend}>
										<div className={styles.flexWidth}>
											<Icon name="building" />
											<div className={styles.titleBox}>
												Asignar Grupos<span className={styles.required}> *</span>
											</div>
										</div>
									</legend>

									<div className={styles.rowBox}>
										<div>
											<div className={styles.filterGroupContainer}>
												<div className={styles.radioItem}>
													<Radio
														name="radioGroupField"
														disabled={modalOption !== "Add"}
														value="Sucursal"
														checked={groupField === "Sucursal"}
														onChange={() => {
															groupFilter("Sucursal", groupsData);
														}}
													/>
													<span className={styles.radioLabel}>Sucursal</span>
												</div>

												<div className={styles.radioItem}>
													<Radio
														name="radioGroupField"
														disabled={modalOption !== "Add"}
														value="Departamento"
														checked={groupField === "Departamento"}
														onChange={() => {
															groupFilter("Departamento", groupsData);
														}}
													/>
													<span className={styles.radioLabel}>Departamento</span>
												</div>

												<div className={styles.radioItem}>
													<Radio
														name="radioGroupField"
														disabled={modalOption !== "Add"}
														value="Todo"
														checked={groupField === "Todo"}
														onChange={() => {
															groupFilter("Todo", groupsData);
														}}
													/>
													<span className={styles.radioLabel}>Todo</span>
												</div>
											</div>

											<div className={styles.containerDisponibles}>
												<List>{renderListDisponibles}</List>
											</div>
											<div className={styles.TextCont}>
												<Button
													className={styles.buttonAgregar}
													disabled={isEmpty(groupDateAdd) || modalOption === "Watch"}
													onClick={() => {
														passDataConfirm();
													}}
													icon
													labelPosition="right">
													Agregar
													<Icon name="right arrow" />
												</Button>
											</div>
										</div>
										<div className={styles.contIcon}>
											<Icon className={styles.IconArrow} name="arrow alternate circle right outline" size="big" />
										</div>
										<div>
											<Text className={styles.TextSeleccionados}>Grupos Asignados:</Text>
											<div className={styles.containerSeleccionados}>
												<List>{renderListSelecionados}</List>
											</div>
											<div className={styles.TextContDel}>
												<Button
													className={styles.buttonAgregar}
													disabled={isEmpty(groupDateRejected) || modalOption === "Watch"}
													onClick={() => {
														passDataDelete();
													}}
													icon
													labelPosition="left">
													<Icon name="left arrow" />
													Remover
												</Button>
											</div>
										</div>
									</div>
								</fieldset>
							</div>
						</div>
					</Form>
				</div>
			</IKModal>

			{open && (
				<ConfirmModal
					visible
					header="Salir del formulario"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={modalOpen}
					buttonLabel="Salir"
				/>
			)}
		</>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		companyName: company.name,
		userName: user.name,
	};
}

invitations.propTypes = {
	tableValue: PropTypes.array,
	onClose: PropTypes.func,
	typesList: PropTypes.array,
	groupsData: PropTypes.array,
	apiData: PropTypes.func,
	dispatch: PropTypes.func,
	tagsList: PropTypes.array,
	modalCrud: PropTypes.string,
};
export default connect(mapStateToProps)(invitations);
